module.exports = __webpack_public_path__ + "img/refresh-player-active.2201c146.svg";